"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "share-links" };
const ShareButton_vue_1 = __importDefault(require("./ShareButton.vue"));
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ShareLinks',
    props: {
        platforms: {
            type: Array,
            default: () => ['facebook', 'twitter', 'email'],
        },
        extraPlatforms: {
            type: Array,
            default: () => [],
        },
        url: {
            type: String,
            default: window.location.href,
        },
        title: {
            type: String,
            default: document.title,
        },
        image: {
            type: String,
            default: null,
        },
    },
    emits: ['share-link-clicked'],
    setup(__props, { emit }) {
        const props = __props;
        const defaultPlatforms = [
            {
                name: 'whatsapp',
                href: 'whatsapp://send?text=%URL%',
                width: null,
                height: null,
                sameWindow: true,
            },
            {
                name: 'facebook',
                href: 'https://www.facebook.com/sharer/sharer.php?u=%URL%',
                width: 400,
                height: 500,
            },
            {
                name: 'twitter',
                href: 'https://twitter.com/intent/tweet?status=%TITLE%+-+%URL%',
                width: 540,
                height: 260,
            },
            {
                name: 'pinterest',
                href: 'http://pinterest.com/pin/create/button/?url=%URL%&description=%TITLE%&media=%IMAGE%',
                width: 520,
                height: 570,
            },
            {
                name: 'tumblr',
                href: 'http://www.tumblr.com/share/link?url=%URL%',
                width: 500,
                height: 500,
            },
            {
                name: 'linkedin',
                href: 'https://www.linkedin.com/sharing/share-offsite/?url=%URL%',
                width: 520,
                height: 570,
            },
            {
                name: 'email',
                href: 'mailto:?subject=%TITLE%',
                width: null,
                height: null,
            },
        ];
        const activePlatforms = (0, vue_3.computed)(() => {
            let active_platforms = [];
            if (props.platforms.length === 0) {
                active_platforms.push(...defaultPlatforms);
                active_platforms.push(...props.extraPlatforms);
                return active_platforms;
            }
            active_platforms.push(...defaultPlatforms.filter((platform) => {
                return !!props.platforms.find((platform_name, index, obj) => {
                    return platform_name === platform.name;
                });
            }));
            active_platforms.push(...props.extraPlatforms);
            return active_platforms;
        });
        const finalImage = (0, vue_3.computed)(() => {
            if (props.image) {
                return props.image;
            }
            let image = '';
            let og_image = document.querySelector('meta[property="og:image"]');
            if (og_image) {
                image = og_image.getAttribute('content');
            }
            else {
                var images = document.getElementsByTagName('img');
                if (images.length > 0) {
                    image = images[0].getAttribute('src');
                }
            }
            return image;
        });
        function makeHref(platform) {
            let href = platform.href
                .replace('%URL%', encodeURIComponent(props.url).replace(/%20/g, '+'))
                .replace('%TITLE%', encodeURIComponent(props.title).replace(/%20/g, '+'));
            if (finalImage === null) {
                return href;
            }
            return platform.href.replace('%IMAGE%', encodeURIComponent(finalImage).replace(/%20/g, '+'));
        }
        function onShareLinkClicked(platform, url) {
            emit('share-link-clicked', platform, url);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.renderSlot)(_ctx.$slots, "before"),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(activePlatforms), (platform) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ShareButton_vue_1.default, {
                        key: platform.name,
                        href: makeHref(platform),
                        name: platform.name,
                        width: platform.width,
                        height: platform.height,
                        "same-window": platform.sameWindow || false,
                        onShareLinkClicked: onShareLinkClicked
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.renderSlot)(_ctx.$slots, platform.name, {}, () => [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(platform.name), 1)
                            ])
                        ]),
                        _: 2
                    }, 1032, ["href", "name", "width", "height", "same-window"]));
                }), 128)),
                (0, vue_2.renderSlot)(_ctx.$slots, "after")
            ]));
        };
    }
});
